'use strict';
// import debug from 'debug/src/browser';
import bunyan from 'browser-bunyan';
import {DEVELOP} from '../constants/environments';
import {errorStream} from './ErrorStream';
import {serverStream} from './ServerStream';


/*
 * Toggling loggers:
 * src: https://github.com/trentm/node-bunyan/issues/317
 *
 * ````
 *    var log = bunyan.createLogger({ name: 'foo', level: 'error'});
 *    var childLog = log.child({level: 'info'});
 *
 *    log.info('should not appear');
 *
 *    childLog.info('should appear');
 * ````
 */

const streams = [{
  level: 'info',
  stream: new bunyan.ConsoleFormattedStream({logByLevel: true}),
}];

// if (process.env.ENVIRONMENT === DEVELOP) {
streams.push({
  type: 'raw',
  level: 'error',
  stream: errorStream,
});
// } else {
//   streams.push({
//     type: 'raw',
//     level: 'error',
//     stream: serverStream,
//   });
// }

export const rootLogger = bunyan.createLogger({
  name: 'app',
  streams,
  serializers: bunyan.stdSerializers,
  src: true,
});

export const globalLogger = buildLogger('global');

// Configure middleware options
/**
 *
 * @param {String} name
 * @param {Object} [options]
 * @return {*}
 */
export function buildLogger(name, options) {
  return options
    ? rootLogger.child({childName: name, ...options})
    : rootLogger.child({childName: name});
}

/**
 *
 * @param {String} module - module name prefix for loggers created per-file
 * @return {function(*): *}
 */
export function makeModuleLogger(module) {
  return name => buildLogger(`${module}/${name}`);
}

try {
  global.window.onerror = function (message, file, line) {
    globalLogger.error({file, line, message}, 'An uncaught error occurred');
  };
} catch (e) {
}



// WEBPACK FOOTER //
// ./src/js/config/logger/index.js